import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private _http: HttpClient) {}

  uploadProfilePhoto(formData: FormData): Observable<any> {
    const _token = sessionStorage.getItem('vtTokenKey') || localStorage.getItem('vtTokenKey');
    let headers = new HttpHeaders().set('authorization', `Bearer ${_token}`);
    return this._http
      .post(`${environment.servicePath}/lfuser/upload_profile_photo`, formData, { headers: headers })
      .pipe(
        take(1),
        map((data: any) => data)
      );
  }

  deleteAccount(): Observable<any> {
    const _token = sessionStorage.getItem('vtTokenKey') || localStorage.getItem('vtTokenKey');
    let headers = new HttpHeaders().set('authorization', `Bearer ${_token}`);
    return this._http.delete(`${environment.servicePath}/lfuser`, { headers: headers }).pipe(
      take(1),
      map((data: any) => data)
    );
  }

  updateProfilePhoto(payload: any): Observable<any> {
    const _token = sessionStorage.getItem('vtTokenKey') || localStorage.getItem('vtTokenKey');
    let headers = new HttpHeaders()
      .set('authorization', `Bearer ${_token}`)
      .set('content-type', 'application/json;charset=UTF-8');
    return this._http.post(`${environment.servicePath}/lfuser/save_profile_photo`, payload, { headers: headers }).pipe(
      take(1),
      map((data: any) => data)
    );
  }

  updatePersonalInfo(payload: any): Observable<any> {
    const _token = sessionStorage.getItem('vtTokenKey') || localStorage.getItem('vtTokenKey');
    let headers = new HttpHeaders().set('authorization', `Bearer ${_token}`);
    return this._http.post(`${environment.servicePath}/lfuser/profile`, payload, { headers: headers }).pipe(
      take(1),
      map((data: any) => data)
    );
  }

  updatePassword(payload: any): Observable<any> {
    const _token = sessionStorage.getItem('vtTokenKey') || localStorage.getItem('vtTokenKey');
    let headers = new HttpHeaders().set('authorization', `Bearer ${_token}`);
    return this._http.post(`${environment.servicePath}/lfuser/update_values`, payload, { headers: headers }).pipe(
      take(1),
      map((data: any) => data)
    );
  }

  validatePassword(payload: any): Observable<any> {
    const OAUTH_KEY = 'LFCWSAPICONSUMERKEY';
    let ts: any = new Date();
    ts = parseInt((ts.getTime() / 1000).toString());
    const nonce = ts + Math.random();
    let headers = new HttpHeaders().set(
      'authorization',
      'OAuth oauth_consumer_key="' +
        OAUTH_KEY +
        '",oauth_nonce="' +
        nonce +
        '",oauth_timestamp="' +
        ts +
        '",oauth_signature="TEZDV1NBUElDT05TVU1FUlNFQ1JFVA=="' +
        ',oauth_token=""'
    );
    return this._http.post(`${environment.servicePath}/lfuser/validate_password`, payload, { headers: headers }).pipe(
      take(1),
      map((data: any) => data)
    );
  }
}
